import React from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Button, Space, Typography } from "antd";
import { LogoutOutlined } from "@ant-design/icons";

const { Header: AntHeader } = Layout;
const { Title } = Typography;

const Header = () => {
  const navigate = useNavigate();

  const onLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <AntHeader
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "#fff",
        padding: "0 24px",
        borderBottom: "1px solid #f0f0f0",
        position: "sticky",
        top: 0,
        zIndex: 10,
        height: 64,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <img
          src={require("../../Assets/images/Moveinout-Logo.svg").default || require("../../Assets/images/Moveinout-Logo.svg")}
          alt="Moveinout-Logo"
          style={{ height: 28, display: "block" }}
        />
        <Title level={5} style={{ margin: 0, color: "#0F1543", lineHeight: "28px" }}>
          Admin Dashboard
        </Title>
      </div>
      <Button
        type="text"
        icon={<LogoutOutlined />}
        onClick={onLogout}
        danger
      >
        Logout
      </Button>
    </AntHeader>
  );
};

export default Header;
